const php = `php
<?php
function main()
{
    $API_KEY = "";
    $API_SECRET = "";
    $HOST = "HHOOSSTT";
    $api = [
        "uri" => "AAPPII",
        "method" => "MMEETTHHOODD",
        // "payload" => [
        //     "symbol" => "BTC-USDT"
        // ],
        "payload" => [
            "example_parameter" => ""
        ],
        "protocol" => "https"
    ];

    doRequest($api["protocol"], $HOST, $api["uri"], $api["method"], $API_KEY, $API_SECRET, $api["payload"]);
}

function doRequest($protocol, $host, $api, $method, $API_KEY, $API_SECRET, $payload)
{
    $timestamp = round(microtime(true) * 1000);
    $parameters = "timestamp=" . $timestamp;

    if ($payload != null) {
        foreach ($payload as $key => $value) {
            $parameters .= "&$key=$value";
        }
    }

    $sign = calculateHmacSha256($parameters, $API_SECRET);
    $url = "{$protocol}://{$host}{$api}?{$parameters}&signature={$sign}";

    echo "protocol: {$protocol}\n";
    echo "method: {$method}\n";
    echo "host: {$host}\n";
    echo "api: {$api}\n";
    echo "parameters: {$parameters}\n";
    echo "sign: {$sign}\n";
    echo "{$method} {$url}\n";

    $options = [
        "http" => [
            "header" => "X-BX-APIKEY: {$API_KEY}\r\n",
            "method" => $method
        ],
        "ssl" => [
            "verify_peer" => false,
            "verify_peer_name" => false
        ]
    ];

    $context = stream_context_create($options);
    $response = file_get_contents($url, false, $context);

    echo "Response body: {$response}\n";
}

function calculateHmacSha256($input, $key)
{
    $hash = hash_hmac("sha256", $input, $key, true);
    $hashHex = bin2hex($hash);
    return strtolower($hashHex);
}

main();`
export default  php



// WEBPACK FOOTER //
// ./src/utils/code/php.js